// Shower flow-reducer catalog — Neoperl reference data.
// Showers have no faucet_type subtype dimension (unlike faucets), so entries carry no
// `compatibleFaucetTypes` field — it's never read for this catalog (hasSubtypeGrouping=false
// on ShowerSubModule).
//
// Only `id`, `brand`, `model`, `flowRateLMin`, `technology` and `priceEur` are currently read by
// FlowReductionWizard's model picker. The remaining fields (reference, family, connectionType,
// pressureRangeBar, pressureCompensated, recommendedApplications, replacementFlowRateLMin,
// temporaryBoostFlowRateLMin, imageUrl) are kept for future use (richer product cards) but not
// yet displayed.
export const SHOWER_REDUCER_CATALOG = [
  {
    id: 'neoperl-ecobooster-shower-6',
    brand: 'Neoperl',
    reference: '180355000',
    family: 'Ecobooster Shower',
    model: 'Ecobooster Shower 6 L/min',
    flowRateLMin: 6,
    priceEur: 15,
    technology: 'Ecobooster Shower',
    connectionType: 'boost',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: 10,
    pressureCompensated: false,
    recommendedApplications: ['Douche', 'Hôtel', 'Logement', 'Vestiaire'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963211/walter%20assets/180355000_L_2_d2bkbx.webp',
    notes: 'Débit réduit à 6 L/min avec possibilité de passer temporairement à 10 L/min.',
  },
  {
    id: 'neoperl-pcw01-5',
    brand: 'Neoperl',
    reference: '588635100',
    family: 'PCW-01',
    model: 'PCW-01 5 L/min',
    flowRateLMin: 5,
    priceEur: 2,
    technology: 'PCW-01',
    connectionType: 'handshower',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Vestiaire', 'Hôtel'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963308/walter%20assets/588635100_L_xfn6qv.webp',
    notes: "S'insère à l'intérieur du pommeau de douche.",
  },
  {
    id: 'neoperl-pcw01-6',
    brand: 'Neoperl',
    reference: '588636100',
    family: 'PCW-01',
    model: 'PCW-01 6 L/min',
    flowRateLMin: 6,
    priceEur: 2,
    technology: 'PCW-01',
    connectionType: 'handshower',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Vestiaire', 'Hôtel'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963304/walter%20assets/588636100_L_rqvdly.webp',
    notes: "S'insère à l'intérieur du pommeau de douche.",
  },
  {
    id: 'neoperl-pcw01-7',
    brand: 'Neoperl',
    reference: '588637100',
    family: 'PCW-01',
    model: 'PCW-01 7 L/min',
    flowRateLMin: 7,
    priceEur: 2,
    technology: 'PCW-01',
    connectionType: 'handshower',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Vestiaire', 'Hôtel'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963301/walter%20assets/588637100_L_mkj6zb.webp',
    notes: "S'insère à l'intérieur du pommeau de douche.",
  },
  {
    id: 'neoperl-pcw01-8',
    brand: 'Neoperl',
    reference: '588638100',
    family: 'PCW-01',
    model: 'PCW-01 8 L/min',
    flowRateLMin: 8,
    priceEur: 2,
    technology: 'PCW-01',
    connectionType: 'handshower',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Vestiaire', 'Hôtel'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963299/walter%20assets/588638100_L_jew2w8.webp',
    notes: "S'insère à l'intérieur du pommeau de douche.",
  },
  {
    id: 'neoperl-pcw01-9',
    brand: 'Neoperl',
    reference: '588639100',
    family: 'PCW-01',
    model: 'PCW-01 9 L/min',
    flowRateLMin: 9,
    priceEur: 2,
    technology: 'PCW-01',
    connectionType: 'handshower',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Vestiaire', 'Hôtel'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963296/walter%20assets/588639100_L_zceeqb.webp',
    notes: "S'insère à l'intérieur du pommeau de douche.",
  },
  {
    id: 'neoperl-pcw02-7',
    brand: 'Neoperl',
    reference: '589089100',
    family: 'PCW-02',
    model: 'PCW-02 7 L/min',
    flowRateLMin: 7,
    priceEur: 2,
    technology: 'PCW-02',
    connectionType: 'hose',
    pressureRangeBar: '1-10',
    temporaryBoostFlowRateLMin: null,
    pressureCompensated: true,
    recommendedApplications: ['Douche', 'Rénovation', 'Hôtel', 'Vestiaire'],
    replacementFlowRateLMin: 15,
    imageUrl: 'https://res.cloudinary.com/dc1felxem/image/upload/v1783963454/walter%20assets/589089100_L_qmzmfk.webp',
    notes: "S'installe entre le flexible et le pommeau. Aucune modification du pommeau nécessaire.",
  },
];
